import { AppstoreOutlined, DeploymentUnitOutlined, RocketOutlined, SettingOutlined, ShopOutlined, TeamOutlined } from "@ant-design/icons";
import type { CardProps } from "antd";
import { Card, List, Typography } from "antd";
import type { FC } from "react";
import { useNavigate } from "react-router";

const { Text } = Typography;

interface QuickLink {
    icon: React.ReactNode;
    title: string;
    path: string;
    description: string;
}

interface QuickLinksCardProps extends CardProps {}

/**
 * QuickLinksCard - Quick navigation to common tasks
 */
export const QuickLinksCard: FC<QuickLinksCardProps> = ({ ...cardProps }) => {
    const navigate = useNavigate();

    const quickLinks: QuickLink[] = [
        {
            icon: <DeploymentUnitOutlined />,
            title: "Terminals",
            path: "/terminals",
            description: "Manage payment terminals",
        },
        {
            icon: <RocketOutlined />,
            title: "Campaigns",
            path: "/campaigns",
            description: "Deploy configurations",
        },
        {
            icon: <ShopOutlined />,
            title: "Sites",
            path: "/sites",
            description: "Manage locations",
        },
        {
            icon: <AppstoreOutlined />,
            title: "Application Profiles",
            path: "/applications-profiles",
            description: "Application profiles",
        },
        {
            icon: <TeamOutlined />,
            title: "Data Groups",
            path: "/data-groups",
            description: "Data group management",
        },
        {
            icon: <SettingOutlined />,
            title: "Configuration Transfer",
            path: "/transfer-configuration",
            description: "Configuration transfer",
        },
    ];

    const handleNavigate = (path: string) => {
        navigate(path);
    };

    return (
        <Card title="Quick Links" size="small" {...cardProps} style={{ backgroundColor: "#FFFFFF", ...cardProps.style }}>
            <List
                size="small"
                dataSource={quickLinks}
                renderItem={(item) => (
                    <List.Item style={{ cursor: "pointer", padding: "8px 0" }} onClick={() => handleNavigate(item.path)}>
                        <List.Item.Meta
                            avatar={
                                <div
                                    style={{
                                        fontSize: 18,
                                        color: "#1890ff",
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    {item.icon}
                                </div>
                            }
                            title={<Text strong>{item.title}</Text>}
                            description={
                                <Text type="secondary" style={{ fontSize: 12 }}>
                                    {item.description}
                                </Text>
                            }
                        />
                    </List.Item>
                )}
            />
        </Card>
    );
};
